import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function bannerCareers() {
    const banner = document.querySelector('.banner--careers');

    if (!banner) {
        return;
    }

    const bgShape1 = gsap.timeline();
    const bgShape2 = gsap.timeline();
    const bgShape = gsap.timeline();
    const headingAnim = gsap.timeline();

    /* bgShape.set('.bg-shape', {
        y: 100
    }); */
    bgShape.to('.bg-shape', {
        scale: 1,
        //y: 0,
        opacity: 1,
        ease: 'elastic.out(0.5,0.5)',
        duration: 2,
        stagger: 0.3
    });
    bgShape.to('.bg-shape', {
        x: () => gsap.utils.random(-20, 20),
        y: () => gsap.utils.random(-20, 20),
        duration: () => gsap.utils.random(2, 3),
        ease: 'sine.inOut',
        repeat: -1,
        yoyo: true,
        stagger: {
            amount: 0.5,
            from: 'random'
        }
    });

    headingAnim.set('.svg-icon', {
        backgroundSize: '0% 0%'
    });
    headingAnim.to('h1.reveal', {
        opacity: 1,
        duration: 1
    });
    headingAnim.to('p.reveal', {
        opacity: 1,
        duration: 0.2
    });
    headingAnim.fromTo(
        '.svg-icon',
        {
            backgroundSize: '0% 0%'
        },
        {
            backgroundSize: 'auto 100%',
            stagger: 0.2
        },
        '<'
    );

    gsap.to('.hero__content', {
        opacity: 0,
        y: -200,
        scrollTrigger: {
            trigger: '.banner--careers',
            start: 'top 130px',
            scrub: 2
        }
    });

    // BG shapes scroll
    bgShape1.to('.bg-shape__wrapper-1', {
        y: -100,
        rotate: 60,
        scale: 1.5,
        scrollTrigger: {
            trigger: '.banner--careers',
            start: 'clamp(top 130px)',
            end: 'clamp(bottom top)',
            scrub: 2
        }
    });
    bgShape2.to('.bg-shape__wrapper-2', {
        y: -200,
        rotate: -90,
        scale: 1.25,
        scrollTrigger: {
            trigger: '.banner--careers',
            start: 'clamp(top 130px)',
            end: 'clamp(bottom top)',
            scrub: 2
        }
    });
}
